import types from '@/vuex/ui/mutations-types.js'

const mutations = {
  [types.SHOW_GLOBAL_LOADING]: (state, payload) => {
    state.globalLoadingMessageArray.unshift(payload.globalLoadingTitle)
    state.globalLoading = true
  },
  [types.HIDE_GLOBAL_LOADING]: (state, payload) => {
    let achou = false
    if (payload && payload.globalLoadingTitle) {
      for (let i = 0; i < state.globalLoadingMessageArray.length; i++) {
        if (state.globalLoadingMessageArray[i] === payload.globalLoadingTitle) {
          state.globalLoadingMessageArray.splice(i, 1)
          achou = true
          break
        }
      }
    }
    // Se não tiver payload ou a mensagem estiver errada, tira uma mensagem
    // qualquer para o loading não ficar rodando infinitamente
    if (achou === false) {
      state.globalLoadingMessageArray.pop()
    }
    if (state.globalLoadingMessageArray.length === 0) {
      state.globalLoading = false
    }
  },
  [types.SHOW_SNACKBAR]: (state, payload) => {
    state.snackbarType = payload.snackbarType
    state.snackbarText = payload.snackbarText
    state.snackbar = true
    setTimeout(() => { state.snackbar = false }, 20000)
  },
  [types.HIDE_SNACKBAR]: (state) => {
    state.snackbar = false
  },
  [types.SHOW_CONFIRMATION_DIALOG]: (state, payload) => {
    state.confirmationDialogConfig.textoPergunta = payload.textoPergunta ? payload.textoPergunta : 'Deseja proceder com sua ação?'
    state.confirmationDialogConfig.textoConteudo = payload.textoConteudo ? payload.textoConteudo : 'Ao confirmar, sua ação será executada. Cancele caso não tenha certeza e acesse nossa seção de ajuda.'
    state.confirmationDialogConfig.textoNao = payload.textoNao ? payload.textoNao : 'Não'
    state.confirmationDialogConfig.textoSim = payload.textoSim ? payload.textoSim : 'Sim'
    state.confirmationDialogConfig.confirmacaoCallback = payload.confirmacaoCallback
    state.confirmationDialog = true
  },
  [types.HIDE_CONFIRMATION_DIALOG]: (state) => {
    state.confirmationDialog = false
  },
  [types.SHOW_MENSAGEM]: (state, payload) => {
    state.exibirMensagem = true
  },
  [types.HIDE_MENSAGEM]: (state) => {
    state.exibirMensagem = false
  },
  [types.SET_MENSAGEM]: (state, payload) => {
    state.tituloMensagem = payload.titulo
    state.textoMensagem = payload.texto
  },
  [types.SET_TEXTO_MENSAGEM]: (state, payload) => {
    state.textoMensagem = payload
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/vuex/ui/mutations.js